<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 14H8C9.63573 14 11.088 14.7855 12.0002 15.9998C12.864 14.8494 14.2129 14.0839 15.7433 14.0065L16 14H17C19.7614 14 22 16.2386 22 19C22 19.5523 21.5523 20 21 20C20.4872 20 20.0645 19.614 20.0067 19.1166L19.9949 18.8237C19.907 17.3072 18.6928 16.093 17.1763 16.0051L17 16H16C14.3431 16 13 17.3431 13 19C13 19.5128 12.614 19.9355 12.1166 19.9933L12 20C11.4872 20 11.0645 19.614 11.0067 19.1166L10.9949 18.8237C10.907 17.3072 9.69275 16.093 8.17627 16.0051L8 16H7C5.34315 16 4 17.3431 4 19C4 19.5523 3.55228 20 3 20C2.44772 20 2 19.5523 2 19C2 16.3112 4.12231 14.1182 6.78311 14.0046L7 14ZM7 4C9.20914 4 11 5.79086 11 8C11 10.2091 9.20914 12 7 12C4.79086 12 3 10.2091 3 8C3 5.79086 4.79086 4 7 4ZM17 4C19.2091 4 21 5.79086 21 8C21 10.2091 19.2091 12 17 12C14.7909 12 13 10.2091 13 8C13 5.79086 14.7909 4 17 4ZM7 6C5.89543 6 5 6.89543 5 8C5 9.10457 5.89543 10 7 10C8.10457 10 9 9.10457 9 8C9 6.89543 8.10457 6 7 6ZM17 6C15.8954 6 15 6.89543 15 8C15 9.10457 15.8954 10 17 10C18.1046 10 19 9.10457 19 8C19 6.89543 18.1046 6 17 6Z"
    fill="currentColor"
  />
</svg>
